__turbopack_context__.v({
  "expandButton": "Foj-la_expandButton",
  "expandButtonCollapsed": "Foj-la_expandButtonCollapsed",
  "wrapper": "Foj-la_wrapper",
});
